import { ConfigProvider } from "antd";

const withAntdTheme = (Component) => () =>
  (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#ED1C24",
          fontFamily: "Urbanist",
        },
        components: {
          Button: {
            borderRadiusLG: 0,
            fontWeight: "bold",
            controlHeightLG: 60,
            paddingInlineLG : 50
          },
          Input: {
            controlHeight: 50,
            colorTextPlaceholder: "#5D666F",
          },
          Select: {
            controlHeight: 50,
            colorTextPlaceholder: "#5D666F",
          },
        },
      }}
    >
      <Component />
    </ConfigProvider>
  );

export default withAntdTheme;
